import { useState } from 'react'
import KeyMetricsButton from './ButtonKeyMetrics'
import RunRateButton from './ButtonRunRate'
import TableKeyMetrics from './TableKeyMetrics'
import TableRunRate from './TableRunRate'
import YearMonthDropdown from './YearMonthDropdown'
import './reporting.scss'
import './SetBudget.scss'
import { AgxColumn, AgxRow } from '@urbanx/agx-ui-components'
import SetBudget from './SetBudget'
import ExportDropdown from './ExportDropdown'

import { PageLayout } from 'layout'
import dayjs from 'dayjs'
import useExecutiveKeyMetrics from 'services/functions/rex/reporting/useExecutiveKeyMetrics'
import useExecutiveRunRateMetrics from 'services/functions/rex/reporting/useExecutiveRunRateMetrics'

export enum TableMetricsType {
  KeyMetrics,
  RunRate,
}

const StaffReporting = () => {
  const [tableMetrics, setTableMetrics] = useState<TableMetricsType>(
    TableMetricsType.KeyMetrics
  )

  const [selectedMonth, setSelectedMonth] = useState(() =>
    dayjs().format('YYYY-MM-DD')
  )

  const { data: keyMetricsStatistics } = useExecutiveKeyMetrics(
    selectedMonth,
    tableMetrics === TableMetricsType.KeyMetrics
  )

  const { data: runRateStatistics } = useExecutiveRunRateMetrics(
    selectedMonth,
    tableMetrics === TableMetricsType.RunRate
  )

  return (
    <PageLayout
      agentName={''}
      primaryPageTitle="Reporting"
      currentPageTitle="Executive"
    >
      <AgxColumn extraClasses="executive-dashboard-content">
        <AgxRow spaceBetween centered extraClasses="metrics-header">
          <AgxRow extraClasses="metrics-header-left">
            <KeyMetricsButton
              onClick={() => setTableMetrics(TableMetricsType.KeyMetrics)}
              isActive={tableMetrics === TableMetricsType.KeyMetrics}
            />
            <RunRateButton
              onClick={() => setTableMetrics(TableMetricsType.RunRate)}
              isActive={tableMetrics === TableMetricsType.RunRate}
            />
          </AgxRow>
          <div className="metrics-header-right">
            <YearMonthDropdown
              selectedMonth={selectedMonth}
              setSelectedMonth={setSelectedMonth}
            />
            {tableMetrics === TableMetricsType.KeyMetrics && <SetBudget />}
            <ExportDropdown
              tableMetrics={tableMetrics}
              keyMetricsData={keyMetricsStatistics}
              runRateData={runRateStatistics}
            />
          </div>
        </AgxRow>
        {tableMetrics === TableMetricsType.KeyMetrics && (
          <TableKeyMetrics keyMetricsData={keyMetricsStatistics} />
        )}
        {tableMetrics === TableMetricsType.RunRate && (
          <TableRunRate runRateData={runRateStatistics} />
        )}
      </AgxColumn>
    </PageLayout>
  )
}

export default StaffReporting
